import { Injectable } from '@angular/core';
import { NavController } from 'ionic-angular';

@Injectable()
export class NavProvider {
  private navCtrl: NavController;

  setNavController(navCtrl: NavController) {
    this.navCtrl = navCtrl;
  }

  navegarParaLogin() {
    this.navCtrl ? this.navCtrl.setRoot('LoginPage') : console.error('NavController não está disponível.');
  }
}



// WEBPACK FOOTER //
// ./src/providers/nav/nav.ts